module.exports = __webpack_public_path__ + "img/face-recognition250.5a91a62f.png";